import React, { useState, useEffect } from 'react';
import { getFlat, getAmount, getReport, getMailReport, getQRCoge } from '../../util/axios_utils';
import LoadingIndicator from '../../common/LoadingIndicator';
import NotFound from '../../common/NotFound';
import EventBus from '../../common/EventBus';
import ServerError from '../../common/ServerError';
import CheckAuthentication from '../../common/CheckAuthentication';
import { NumericFormat } from "react-number-format";
import { getPeriodNames } from '../../util/Helpers';
import { Select, Button, notification, Typography, Modal, QRCode } from "antd";
import './Amount.css';
import '../../App.css'
import Table from '../../components/Table';
import { DownloadOutlined, MailOutlined } from "@ant-design/icons";
// import { createWidget } from '@sber-ecom-core/sberpay-widget';
// import Styled from "styled-components";

const { Option } = Select;

const Amount = (props) => {
    // const [amounts, setAmounts] = useState([]);
    // const { username } = useParams();

    const {
        isAuthenticated,
        currentUser
    } = props;
    const [user] = useState(currentUser.username);
    const [modaldata, setmodaldata] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [serverError] = useState(false);
    // const [comission, setcomission] = useState(0);
    // const [total, settotal] = useState(0);
    // const [flatid, setFlatId] = useState();
    // const [selectedflat, setSelectedFlat] = useState();
    const [flats, setFlats] = useState([]);
    // const [user, setUser] =useState();
    const init = {
        flats: [],
        address: 'Выбор помещения',
        // // user: null,
        // isLoading: false,
        // error: null,
        // selectedFlatId: null,
        // selectedFlat: null,
        btdisable: true,
        // validatestatus: ''
    };
    const [store, setStore] = useState(init);

    // WHEN A USER IS SELECTED
    const handleFlatSelect = (flatId) => {

        // setFlatId(flatId);
        let flat = flats.find(item => item.flat === flatId);
        // setSelectedFlat(flat);
        if (user !== null) {
            setStore({
                ...store,
                isLoading: true
            })
        }
        const request = {
            right: flat.right,
            period: flat.period
        }
        getAmount(request)
            .then(response => {
                setStore({
                    ...store,
                    amounts: response.listAmount,
                    // originData: response.listAmount,
                    isLoading: false, btdisable: false,
                    selectedFlatId: flatId,
                    selectedFlat: flat,
                    address: flat.address
                });
                // setAmounts(response.listAmount);
            }).catch(error => {
                if (error.status === 404) {
                    setStore({
                        ...store,
                        notFound: true,
                        isLoading: false, btdisable: false,
                        selectedFlatId: flatId,
                        selectedFlat: flat
                    });
                } else if (error.status === 406) {
                    setStore({
                        ...store,
                        serverError: true,
                        isLoading: false, btdisable: false,
                        selectedFlatId: flatId,
                        selectedFlat: flat
                    });
                    EventBus.dispatch("handleLogout");
                } else {
                    setStore({
                        ...store,
                        serverError: true,
                        isLoading: false, btdisable: false,
                        selectedFlatId: flatId,
                        selectedFlat: flat
                    });
                }
            });
    }

    const Report = () => {
        const flat = store.selectedFlat;
        setIsLoading(true);
        if (user !== null) {
            setStore({
                ...store,
                isLoading: true
            })
        }
        const request = {
            right: flat.right,
            period: flat.period
        }
        getReport(request)
            .then(response => {
                setIsLoading(false);
            })
            .catch(error => {
                if (error.status === 404) {
                    setIsLoading(false);
                    setNotFound(true);
                } else if (error.status === 406) {
                    setIsLoading(false);
                    EventBus.dispatch("handleLogout");
                } else {
                    setIsLoading(false);
                }
            });
    }
    const MailReport = () => {
        const flat = store.selectedFlat;
        const request = {
            right: flat.right,
            period: flat.period
        }
        getMailReport(request)
            .then(response => {
                setStore({
                    ...store,
                    user: response,
                    isLoading: false
                });
                notification.success({
                    message: 'Портал ЖКХ',
                    description: response.data,
                });
            }).catch(error => {
                if (error.status === 404) {
                    setStore({
                        ...store,
                        notFound: true,
                        isLoading: false
                    });
                } else if (error.status === 406) {
                    setStore({
                        ...store,
                        serverError: true,
                        isLoading: false
                    });
                    EventBus.dispatch("handleLogout");
                } else {
                    setStore({
                        ...store,
                        serverError: true,
                        isLoading: false
                    });
                    notification.error({
                        message: 'Портал ЖКХ',
                        description: 'Извините! Что-то пошло не так. Пожалуйста, попробуйте позднее!'
                    });
                }
            });
    }

    const columns = [
        {
            title: 'Период',
            dataIndex: 'period',
            key: 'period',
            editable: false,
            render: (text) => getPeriodNames(text)
        },
        {
            title: 'Наименование',
            dataIndex: 'namevkvit',
            key: 'namevkvit',
            editable: false,
            // render(text) {
            //     return {
            //       props: {
            //         style: { color: '#1890FF' }
            //       },
            //       children: <div>{text}</div>
            //     };
            //   }
        },
        {
            title: 'Лицевой счет',
            dataIndex: 'accname',
            key: 'accname',
            editable: false,
            // render: (text)=> <a>{text}</a>
        },
        {
            title: 'Начислено',
            dataIndex: 'amount1',
            key: 'amount1',
            editable: false,
            inputType: "nsumm",
            align: "right",
            render: (text) => <NumericFormat decimalScale={2} fixedDecimalScale={true} displayType="text" value={text} />
        },
        {
            title: 'Долг (Аванс)',
            dataIndex: 'dolg',
            key: 'dolg',
            editable: false,
            inputType: "summ",
            align: "right",
            // render: (text)=>  <NumberFormat decimalScale={2} fixedDecimalScale={true} displayType="text" value={text} />
            // render(text) {
            //     return {
            //       props: {
            //         style: { color: parseFloat(text) > 0 ? "red" : "green" }
            //       },
            //       children: <NumberFormat decimalScale={2} fixedDecimalScale={true} displayType="text" value={text} />
            //     };
            //   }
        },
        {
            title: 'К оплате',
            dataIndex: 'amount',
            key: 'amount',
            editable: true,
            inputType: "summ",
            align: "right",
            // render: (text)=>  <NumberFormat decimalScale={2} fixedDecimalScale={true} displayType="text" value={text} />
        },
        {
            dataIndex: "gpay",
            title: "Оплата",
            editable: false,
            render: (index, record) => ( <Button type="primary" disabled={false}
                onClick={() => showModal(record)}> QR Код</Button>
                )
        }
    ];
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = (record) => {
        const request = {
            account: record.account,
            period: record.period
        }
        getQRCoge(request).then(response => {
            setIsModalOpen(true);
            setmodaldata(response);
        }).catch(error => {
            console.log(error);
        });
        // console.log('record ',record);
        // console.log('modaldata1 ',modaldata)
        // setmodaldata((old) => ({ ...old, sumcomission: round(record.amount * record.comission / (100 - old.comission), 2), total: Number(record.amount) + round(record.amount * record.comission / (100 - old.comission), 2), isOKdisabled: round(record.amount * (1 + record.comission / (100 - old.comission)), 2) === 0 }));
        // console.log('modaldata2 ',modaldata);
        // setisOKdisabled(modaldata.total==0);

    };
//     const sberpay = (record) => {
//         const widget = createWidget('localhost');
// const WidgetParams = {
//     bankInvoiceId: '123',
//     backUrl: 'string',
//     bindingId: 'b6c15da1-dd13-a64c-42d9-4c5ca70ab183',
//     userName: 'ЮМани',
//     lifeTime: 100,
//     expirationDate: 100,
//     isFinishPage: true,
//     finishPageTimeOut: 10,

// };
//         widget.open(WidgetParams);
//     }
    const handleOk = () => {
        setIsModalOpen(false);
    }
    const handleCancel = () => {
        setIsModalOpen(false);
    }


    useEffect(() => {
        setmodaldata(() => ({ sumcomission: 0, total: 0, isOKdisabled: false }));
        if (user !== null) {
            setIsLoading(true);
            getFlat()
                .then(response => {
                    setFlats(response.listFlat);
                    setIsLoading(false);
                }).catch(error => {
                    if (error.status === 404) {
                        setNotFound(true);
                        setIsLoading(false);
                    } else if (error.status === 406) {
                        setNotFound(true);
                        setIsLoading(false);
                        EventBus.dispatch("handleLogout");
                    } else {
                        setNotFound(true);
                        setIsLoading(false);
                    }
                });
        }

    }, [user]);

    if (isLoading) {
        return <LoadingIndicator />;
    }

    if (notFound) {
        return <NotFound />;
    }

    if (serverError) {
        return <ServerError />;
    }
    if (!isAuthenticated) {
        return <CheckAuthentication {...props} />
    }

    return (
        <div className="home-content">
            {
                currentUser.username ? (
                    <div>
                        <Typography.Title level={3}>Платежные документы</Typography.Title>
                        <Select
                            className="select"
                            defaultValue="Выбор помещения"
                            style={{ width: 500, marginBottom: 20 }}
                            onChange={handleFlatSelect}
                            value={store.address}
                        >
                            {flats.map((flat) => (
                                <Option key={flat.flat} value={flat.flat}>
                                    {flat.address}
                                </Option>
                            ))}
                        </Select>
                        <div>
                            <Table
                                headers={columns}
                                rows={store.amounts}
                            />
                            <Modal title="" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} width={250} >
                                <h4>QR код для оплаты <QRCode value={modaldata} size={200} /></h4>
                            </Modal>
                            <table className="button-table">
                                <tbody>
                                    <tr>
                                        <td>
                                            <Button type="primary" htmlType="submit" size="large" className="login-form-button button" icon={<DownloadOutlined />} onClick={() => Report()} disabled={store.btdisable} >Загрузить платежный документ</Button>
                                        </td>
                                        <td>
                                            <Button type="primary" htmlType="submit" size="large" className="login-form-button button" icon={<MailOutlined />} onClick={() => MailReport()} disabled={store.btdisable} >Отправить на электронную почту</Button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                ) : null
            }

        </div>
    )

}
// const ButtonGroupTableEditContainer = Styled.div`
//   width: 65px;
//   margin: 0 5px;
//   display: flex;
//   justify-content: space-between;
// `;
export default Amount;